<template>
  <div class="input-container"
       :class="{
         'filled': selectedItem,
         'focused': isFocused,
         'disabled': disabled
       }"
       ref="dropdown">
    <span class="placeholder" @click="expand">{{ label }}</span>
    <span class="chevron">
      <b-icon icon="chevron-down" size="is-small"></b-icon>
    </span>
    <div class="select-input" @click="expand">
      <template v-if="selectedItem === true">
        {{selected.value}}
      </template>
      <template v-else>
        {{selectedItem.value}}
      </template>
      <button type="button" class="clear" @click="clear" v-if="!disabled">
        <b-icon icon="close" size="is-small"></b-icon>
      </button>
    </div>
    <div class="options" v-if="expanded">
      <div class="search">
        <b-input :placeholder="$t('interface.search')"
                 :disabled="disabled"
                 v-model="searchInput"
                 ref="search"
                 type="text"
                 icon="magnify">
        </b-input>
      </div>
      <div class="items" v-if="items.length > 0">
        <div class="item" v-for="item in items" @click="select(item)">
          {{item.value}}
        </div>
      </div>
      <div v-else class="has-text-grey has-text-centered mt-20 mb-10 not-found">
        <template v-if="!searchInput.trim()">{{ $t('interface.search') }}</template>
        <template v-else>{{ customNotFoundText || $t('reports.nothingFound') }}</template>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      label: {
        type: String,
        required: false,
        default: ''
      },
      type: {
        type: String,
        required: false,
        default: 'text'
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false
      },
      data: {
        type: Function,
        default: () => []
      },
      customNotFoundText: {
        type: null,
        default: false
      },
      selected: null,
      value: null
    },
    data() {
      return {
        searchInput: '',
        isFocused: false,
        expanded: false,
        items: [],
        selectedItem: !!this.selected
      }
    },
    methods: {
      select(item) {
        this.selectedItem = item
        this.$emit('input', item.key)
        this.$emit('select', item)
        this.close()
      },
      clear() {
        this.selectedItem = false
        this.$emit('input', null)
        this.$emit('select', null)
      },
      expand() {
        if (!this.disabled) {
          this.expanded = true
          this.isFocused = true
          this.$nextTick(() => this.$refs.search.focus())
        }
      },
      close() {
        this.expanded = false
        this.isFocused = false
        this.expanded = false
      },
      documentClick(e) {
        let el = this.$refs['dropdown']
        let target = e.target
        if ((el !== target) && !el.contains(target)) {
          this.close()
        }
      }
    },
    watch: {
      selected(selected) {
        if(selected !== false)
          this.selectedItem = !!selected
      },
      searchInput(q) {
        if (q !== '')
          this.data(q).then(items => this.items = items)
      }
    },
    mounted() {
    },
    created() {
      document.addEventListener('click', this.documentClick)
    },
    destroyed() {
      document.removeEventListener('click', this.documentClick)
    }
  }
</script>

<style lang="scss" scoped>
  .not-found {
    padding: 0 20px;
  }

  .input-container {
    width: 100%;
    height: 52px;
    position: relative;
    ---z-index: 9;

    &.disabled {
      color: #aaaaaa;
    }

    .placeholder {
      position: absolute;
      top: 20px;
      color: #686868;
      z-index: 1;
      font-size: 14px;
      transition: all .2s ease;
    }

    &.filled .placeholder {
      top: 0;
      font-size: 13px;
      color: #afafaf;
    }

    &.focused .placeholder {
      color: #3498db;
    }

    .chevron {
      display: block;
      position: absolute;
      top: 24px;
      right: 0;
    }

    .clear {
      display: block;
      position: absolute;
      top: 10px;
      right: 20px;
      padding: 0 0 0 0;
      margin: 0;
      border: 0;
      background: #e7e7e7;
      border-radius: 50%;
      width: 16px;
      height: 16px;
      text-align: center;
      line-height: 16px;
      font-size: 10px !important;

      &:hover {
        background: #d8d8d8;
        cursor: pointer;
      }
    }

    .select-input {
      display: inline-block;
      height: 34px;
      position: relative;
      background: transparent;
      margin: 18px 0 0 0;
      padding: 6px 41px 8px 0;
      cursor: default;
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      border: 0;
      border-bottom: 1px solid #d7dce9;
      font-size: 14px;
      transition: border-bottom-color .2s ease;
    }

    &.focused .select-input {
      border-color: #3498db;
    }

    .options {
      position: absolute;
      box-shadow: -11px 13px 29px 0 rgba(45, 68, 126, 0.18);
      width: 100%;
      max-height: 350px;
      overflow-y: auto;
      z-index: 99;
      background: #fff;
      padding: 10px 0;
      top: 51px;

      .search {
        margin-top: 6px;
        padding: 0 16px;
      }

      .items {
        margin-top: 10px;
        .item {
          cursor: pointer;
          padding: 8px 15px;

          &:hover {
            background: #f6f6f6;
          }
        }
      }
    }
  }
</style>
